// src/pages/TicketStockOverview/components/StockOverviewList.tsx
// Bảng danh sách kỳ: mã kế hoạch, tổng đã giao, tổng còn lại — bấm "Xem chi tiết" mở popup phiếu
// giao vé của kỳ đó (REQUIRE_FIXBUGS.md mục 8/10).

import React from 'react';
import { Button } from 'reactstrap';
import moment from 'moment';
import DataTableShell, { getSttNumber } from 'Components/Common/DataTableShell';
import { IssuancePlanStockOverview, StockOverviewPagination } from '../types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('ticket_stock_overview');

interface StockOverviewListProps {
  items: IssuancePlanStockOverview[];
  pagination: StockOverviewPagination;
  loading: boolean;
  onViewDetail: (item: IssuancePlanStockOverview) => void;
}

const formatDate = (value?: string | null) =>
  value ? moment(value).format('DD/MM/YYYY') : '-';

const formatNumber = (value?: number | null) =>
  typeof value === 'number' ? value.toLocaleString('vi-VN') : '-';

const columnCount = 6;

const StockOverviewList: React.FC<StockOverviewListProps> = ({
  items,
  pagination,
  loading,
  onViewDetail,
}) => (
  <DataTableShell
    headerRow={
      <tr>
        <th className="text-center" style={{ width: 60 }}>{st('stt_column')}</th>
        <th>{st('ma_ke_hoach_column')}</th>
        <th>{st('ngay_quay_du_kien_column')}</th>
        <th className="text-end">{st('tong_da_giao_column')}</th>
        <th className="text-end">{st('tong_con_lai_column')}</th>
        <th style={{ width: 130 }} className="text-center">
          {st('thao_tac_column')}
        </th>
      </tr>
    }
  >
    {loading ? (
      Array.from({ length: 5 }).map((_, row) => (
        <tr key={row}>
          {Array.from({ length: columnCount }).map((__, col) => (
            <td key={col}>
              <div className="placeholder-glow">
                <span className="placeholder col-8"></span>
              </div>
            </td>
          ))}
        </tr>
      ))
    ) : items.length === 0 ? (
      <tr>
        <td colSpan={columnCount} className="text-center text-muted py-5">
          <div className="mb-2">
            <i className="ri-archive-line fs-1 text-muted"></i>
          </div>
          {st('chua_co_ke_hoach_nao_co_text')}
        </td>
      </tr>
    ) : (
      items.map((item, index) => (
        <tr key={item.issuancePlanId}>
          <td className="text-center">{getSttNumber(pagination.currentPage, pagination.pageSize, index)}</td>
          <td>
            <div className="fw-medium text-primary">{item.planCode}</div>
          </td>
          <td>{formatDate(item.expectedDrawDate)}</td>
          <td className="text-end">{formatNumber(item.totalDelivered)}</td>
          <td className="text-end">{formatNumber(item.totalRemaining)}</td>
          <td className="text-center">
            <Button
              color="info"
              outline
              size="sm"
              title={st('xem_chi_tiet_giao_ve_title')}
              data-action-code="button-detail"
              data-action-name="Xem chi tiết giao vé theo kỳ"
              onClick={() => onViewDetail(item)}
            >
              <i className="ri-eye-line align-bottom me-1"></i>
              {st('chi_tiet_button')}
            </Button>
          </td>
        </tr>
      ))
    )}
  </DataTableShell>
);

export default StockOverviewList;
